import { VersionRepository } from "@/domain/repository/version-repository";
import { VersionInfo } from "@/data/info/version-info";
import { SATError, SATResult } from "@sadtx/sat-error";

/**
 * 애플리케이션 버전 정보를 조회하는 유스케이스.
 */
export class VersionCheckUsecase {
  constructor(private readonly versionRepo: VersionRepository) {}

  async execute(): Promise<SATResult<VersionInfo, SATError>> {
    return this.versionRepo.fetchVersion();
  }
}
